import { createI18n, type I18n } from 'vue-i18n'

// 创建 i18n 实例
const i18nInstance = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'zh',
  fallbackLocale: 'zh',
  messages: {
    zh: require('@/assets/lang/system/zh-cn.json'),
    en: require('@/assets/lang/system/en.json')
  }
})

// 类型断言
export const i18n = i18nInstance as I18n<{}, {}, {}, string, false>

// 导出便捷方法
export const $t = (key: string): string => {
  return (i18n.global as any).t(key)
}